import PropTypes from 'prop-types';
import React from 'react';
import { RxCross2 } from 'react-icons/rx';
import classes from './DrawerHeader.module.css';
import { LeftArrowIcon } from '../../Assets/icons';
import Button from '../../Components/UI/Button';
import clsx from 'clsx';
const DrawerHeader = ({ className, setShow, title, setShow2, onClose, prev = true }) => {
  return (
    <header className={clsx(classes.header, className)}>
      <div className={classes.actionInfo}>
        {prev && (
          <Button
            onClick={() => {
              if (typeof setShow2 === 'function') {
            
                setShow2();
                setShow();
              }
            }}
            className={classes.cta}
            variants="transparent"
            label={<LeftArrowIcon />}
          />
        )}
        <h2 className={classes.title}>{title}</h2>
      </div>

      <span
        className="cp"
        onClick={() => {
          if (typeof setShow === 'function') setShow(false);
          if (typeof onClose === 'function') {
            onClose();
          }
        }}>
        <RxCross2 color="var(--icon-color)" size={21} />
      </span>
    </header>
  );
};

DrawerHeader.propTypes = {
  title: PropTypes.string,
  setShow: PropTypes.func.isRequired
};
export default DrawerHeader;
